import { heroStats } from '@/mocks/downloadData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20dark%20background%20with%20warm%20orange%20and%20red%20light%20streaks%20and%20soft%20bokeh%20particles%2C%20moody%20premium%20film%20production%20atmosphere%2C%20high%20contrast%2C%20no%20text%2C%20wide%20composition&width=1920&height=1080&seq=ppsp-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-top object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-4xl mx-auto lg:mx-0 animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm">
            <i className="ri-megaphone-line text-accent-400"></i>
            官方入口 · 手机版安装包持续更新
          </span>

          <h1 className="mt-5 font-heading text-background-50 text-4xl md:text-6xl lg:text-7xl leading-tight tracking-wide">
            啪啪视频 下载与最新地址导航
          </h1>

          <p className="mt-5 max-w-2xl text-background-100 text-sm md:text-base leading-relaxed">
            这里为你整理啪啪视频app下载、官网入口及最新地址。手机版安装包持续更新，换地址不迷路，
            打开页面即可选择下载或在线访问，快速进入资源库。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-lg"></i>
              立即下载手机版
            </a>
            <a
              href="#address"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-link text-lg"></i>
              查看最新地址
            </a>
          </div>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-background-50/15 rounded-lg overflow-hidden border border-background-50/15 max-w-3xl">
            {heroStats.map((stat) => (
              <div key={stat.label} className="bg-black/40 px-4 py-3.5">
                <div className="text-background-100/70 text-xs">{stat.label}</div>
                <div className="mt-1 text-background-50 text-sm md:text-base font-medium">{stat.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}